import {
    setWaitlistListQuery,
    useEventTypesQuery,
    useWaitlistListQuery,
} from '~/lib/Queries';
import { startOfDay } from 'date-fns';
import {
    formatDateLong,
    formatDateTime,
    formatDateTimeLong,
} from '~/lib/DateTime';
import DotDotDotMenu from '~/components/DotDotDotMenu';
import StartEndDateTime from '~/components/forms/StartEndDateTime';
import useDelete from '~/lib/useDelete';
import * as Toast from '~/lib/Toast';
import Select from '~/components/Select';
import { useState } from 'react';
import WaitlistEntry from '~/components/waitlist/WaitlistEntry';

const WaitlistFilters = ({ filters, setFilters }) => {
    const { data: eventTypeData, isLoading } = useEventTypesQuery();
    const eventTypeOptions = [
        {
            label: 'Event Type',
            value: 0,
        },
        ...(eventTypeData || []).map(et => ({
            label: et.name,
            value: et.id,
        })),
    ];

    const timeframeOptions = [
        { value: '', label: 'Upcoming' },
        { value: 'past', label: 'Past' },
    ];

    console.log('eventType=', filters?.eventType);

    return (
        <div className="flex items-center justify-end">
            {!isLoading && (
                <Select
                    inputClassName="max-w-72"
                    options={eventTypeOptions}
                    value={filters?.eventType}
                    onChange={value =>
                        setFilters(old => ({ ...old, eventType: value }))
                    }
                />
            )}
            <Select
                className="ml-4"
                options={timeframeOptions}
                value={filters?.timeframe}
                onChange={value =>
                    setFilters(old => ({ ...old, timeframe: value }))
                }
            />
        </div>
    );
};

function applyFilters(list, filters) {
    if (parseInt(filters?.eventType)) {
        list = list.filter(
            entry =>
                parseInt(entry.event_type_id) === parseInt(filters.eventType),
        );
    }

    const now = new Date();
    list = list.filter(entry => {
        if (filters?.timeframe === 'past') {
            return new Date(entry.end) < now;
        } else {
            return new Date(entry.end) > now;
        }
    });

    return list;
}

const WaitlistList = () => {
    const { data, isLoading } = useWaitlistListQuery();

    const [filters, setFilters] = useState({});

    const list = applyFilters(data?.list || [], filters);
    const listByDate = Object.groupBy(list, entry =>
        startOfDay(entry.start).toISOString(),
    );

    return (
        <div className="max-w-2xl">
            <WaitlistFilters filters={filters} setFilters={setFilters} />
            {Object.keys(listByDate)
                .sort()
                .map(date => (
                    <div key={date}>
                        <div className="panel-label">
                            {formatDateLong(date)}
                        </div>
                        <div className="panel pl-4 mb-6">
                            {listByDate[date].map((entry, idx) => (
                                <WaitlistEntry
                                    key={entry.id}
                                    entry={entry}
                                    isFirst={idx === 0}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            {Object.keys(listByDate)?.length === 0 && (
                <div className="panel p-4 mt-4 text-gray-500">
                    Nobody is on the waitlist.
                    <div className="mt-1">
                        Clients can add themselves to the waitlist from your
                        booking form.
                    </div>
                </div>
            )}
        </div>
    );
};

export default WaitlistList;
